import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const BookingsHeader = ({ searchTerm, onSearchChange, total, onCreateClick }) => {
  const history = useHistory();

  const handleCreateClick = () => {
    if (onCreateClick) {
      onCreateClick();
    } else {
      history.push("/fleet-management/bookings/create");
    }
  };

  return (
    <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
      <div>
        <h4 className="card-title mb-1">Bookings</h4>
        <small className="text-muted">Total: {total}</small>
      </div>

      <div className="d-flex gap-2 align-items-center" style={{ minWidth: "280px", maxWidth: "500px", width: "100%" }}>
        <input
          type="text"
          className="form-control"
          placeholder="Search by customer, company, phone, reg #, status"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button variant="primary" onClick={handleCreateClick} className="flex-shrink-0">
          <i className="feather icon-plus"></i>
        </Button>
      </div>
    </div>
  );
};

export default BookingsHeader;
